module.exports = __webpack_public_path__ + "static/media/library.569fd0bf.png";